import { createRouter, createWebHistory } from 'vue-router';
import commonRoutes from '@routes/index';

let router = null;

export default {
    create: ({ routes = [] } = {}) => {
        if (router) {
            return router;
        }
        const finalRoutes = commonRoutes.map((item) => {
            const customRoute = routes.find(
                (itemCustomRoute) => itemCustomRoute.name === item.name
            );

            return {
                ...item,
                component:
                    customRoute && customRoute.component ? customRoute.component : item.component,
            };
        });

        router = createRouter({
            history: createWebHistory('/'),
            routes: finalRoutes,
            scrollBehavior(to, from, savedPosition) {
                if (savedPosition) {
                    return savedPosition;
                } else if (to.hash) {
                    return { selector: to.hash };
                } else if (
                    to &&
                    to.meta &&
                    to.meta.preserveScrollPosition &&
                    from &&
                    from.meta &&
                    from.meta.preserveScrollPosition
                ) {
                    return null;
                } else {
                    return { left: 0, top: 0 };
                }
            },
        });

        return router;
    },
};
